<template>
<div class="leftsection-start">
    <template v-if="isConsultant">
        <div v-if="isEmployerListLoaded && selectCandidateData.data.length > 1" style="padding: 5px;">
            <label>Select Organization</label>
            <ob-select2 :options="selectCandidateData" v-model="questionCategorydroplist" @input="organizationChange"></ob-select2>
            <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="questionCategorydroplist ==''">Please select a organization to see reports</p>
        </div>
    </template>
    <template v-if="isEmployerListLoaded">
        <template v-if="leftSectionspinner">
            <ob-spinner ></ob-spinner>
        </template>
        <template v-else>
            <div v-if="leftSectionDataDetails && leftSectionDataDetails.length > 0">
                <div class="row m0">
                    <div class="col-md-12 p0">
                        <ob-input icon="fa-search" placeholder="Search FDNS Visit" v-model.trim="searchText"></ob-input>
                    </div>
                </div>            
                <div class="row m0" :class="{active:currentSelectReport == null? false:currentSelectReport == leftData.ReportId ?true :false}" v-for="(leftData, index) in cLeftSectionDataDetails" :key="index" @click="selectLeftSection(leftData)">
                        <div class="data-box-cont">
                        <p>FDNS Visit - {{index+1}}<span class="text-left-count" v-if ="isHRManager"> - {{leftData.ConsultantName}}</span></p>
                        <span><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/user-small-icon.svg`"  class="img-width-candidate"><span class="text-consultant" :title="leftData.ConsultantName">{{leftData.VisitOfficerName}}</span></span>
                        <span class="date-text"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/FDNS/calendar-small-icon.svg`"  class="img-width">{{leftData.VisitDate}}</span>
                        </div>
                </div>
                <p v-if="cLeftSectionDataDetails.length == 0 && searchText != ''" class="text-center"><i>No results found.</i></p>
            </div>
            <div class="MT-Content-table" v-else-if="leftSectionDataDetails == ''">
                <div class="MT-Content nodata-text">No FDNS Visit History report </div>
            </div>
        </template>
    </template>
    <template v-else-if="isConsultant && !isEmployerListLoaded">
        <div class="MT-Content-table">
            <div class="MT-Content">
                <p><i>loading...</i></p>
            </div>
        </div>
    </template>
</div>
</template>
<script>
export default{
    data(){
        return {
            searchText: '',

            isEmployerListLoaded: false,
            questionCategorydroplist: '',
            dataBasedOnSelectCandidate: '',
            selectCandidateData: {
                placeholder: {
                id: "-1",
                text: "Select Organization"
                },
                data: []
            },

            leftSectionspinner:false,
            leftSectionDataDetails: [],
            currentSelectReport:''
        }
    },
    computed: {
        cLeftSectionDataDetails() {
            if(this.leftSectionDataDetails.length > 0) {
                return this.leftSectionDataDetails.filter((leftData) => {
                    return leftData.VisitOfficerName.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1 || leftData.ConsultantName.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1
                })
            } else {
                return []
            }
        },
         isHRManager(){
                // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager
                return false
            },
            isConsultant() {
                // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Consultant
                return true
            },
    },
    created(){
        this.init()
    },
    // watch:{
    //     cLeftSectionDataDetails(){
    //       
    //         if(this.currentSelectReport == '' || this.currentSelectReport == null) {
    //             this.currentSelectReport = this.cLeftSectionDataDetails[0].ReportId
    //             this.selectLeftSection(this.cLeftSectionDataDetails[0])
    //         }
    //     }

    // },
    methods:{
        init() {
            if(this.isHRManager) {
                this.isEmployerListLoaded = true
                this.$store.commit('updateFDNSConsultantId', this.loggedInUserObj.consultantId)
                this.$store.commit('updateFDNSEmpOrgId', this.loggedInUserObj.OrgId)
                this.getReportList(this.loggedInUserObj.OrgId)
            } else if(this.isConsultant) {
                this.initJobSeeker()
            }
        },
        selectLeftSection(k){
            this.currentSelectReport= k.ReportId
            let obj = {}
            obj.ReportId = k.ReportId
            obj.empOrgId = this.$store.getters.getFDNSEmpOrgId
            
            // reset report details
            this.$store.commit('updateFDNSSelectedReportDetails', null)           
			this.$emit('onClick',obj)
        },

        getReportList(OrgId) {
            this.leftSectionspinner = true
            ajax.get(`/FDNSAudit/GetFDNSReportList?empOrgId=${OrgId}`,{},(res) =>{
                if (res.data.State == true){
                 this.leftSectionDataDetails = res.data.FdnsModel
                 this.leftSectionspinner = false
                }
                else{
                    this.leftSectionspinner = false
                    this.ESSEnableDisable(res)
                }
                 
            })
        },

        initJobSeeker() {
            ajax.get(`/OnBoarding/GetAllMyEmployerList`, {}, res => {
                if (res.data.State == true) {
                    this.changeSelectCandidateData = res.data.resultList
                    this.selectCandidateData.data = __.map(res.data.resultList, t => {
                        return {
                        id: t.OrgId,
                        text: t.OrgName,
                        detailedData: t
                        };
                    });
                    // load the first organization questions by default
                    if(res.data.resultList.length > 0) {
                        let firstOrgId = res.data.resultList[0].OrgId

                        this.questionCategorydroplist = firstOrgId
                        this.organizationChange(firstOrgId)
                    }

                    this.isEmployerListLoaded = true
                } else {
                this.ESSEnableDisable(res)
                this.$message({
                    type: "error",
                    message: res.data.Message
                });
                }
            });
		},

        organizationChange(i) {
            this.OrgId = i
			this.changeSelectCandidateData.forEach(o => {
                if (o.OrgId == i) {
                    this.dataBasedOnSelectCandidate = o;
                    this.$emit('dataOrgDetails',o)

                    this.$store.commit('updateFDNSConsultantId', this.loggedInUserObj.consultantId)
                    this.$store.commit('updateFDNSEmpOrgId', i)

                    this.getReportList(i)
                }
            });

		},

    }
}
</script>
<style lang="scss">
.visithistory-leftsection{
    .leftsection-start{
    height: 100%;
    overflow: auto;
}
    .fa-search{
            left: initial !important;
            right: 10px;
            top: 15px;
    }
    input{
        padding: 20px 30px 20px 10px !important;
        border: 0;
        border-bottom: 1px solid #e0e0e0;
        border-radius: 0;
    }
    .date-text{
        float: right;
        transform: translateY(4px);

    }
    .data-box-cont{
        padding: 15px;
        border-bottom: 1px solid #e0e0e0;
        border-top: 1px solid #e0e0e0;
        cursor: pointer;    
    }
    .img-width{
        width: 14px;
        margin-right: 5px;
    }
    .img-width-candidate{
        width: 12px;
        margin-right: 5px;
    }
    p{
        color: #143361;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 3px;
    }
    span{
        color: #8b8d8a;
        font-size: 13px;
        font-weight: 500;
    }
    .active{
       background: #d8d8d8;
    }
}
.text-consultant{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100px;
    display: inline-block;
    transform: translateY(6px);
}
.nodata-text{
    font-size: 12px;
}
.text-left-count{
    color: #143361 !important;
    font-size: 13px;
    font-weight: 600 !important;
    margin-bottom: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNSTabs/FDNSVisitHistoryTab/FDNSVisitHistoryLeftSection.vue